const HeaderTop = ({ children, margin }: any) => {
  return <div style={{ marginTop: margin ? margin : -30 }}>{children}</div>;
};
export default HeaderTop;
